import { useParams } from 'react-router-dom';
import { DEFAULT_LANG, isLang, type Lang } from './site';

/** Текущий язык берётся только из URL (/en/, /pt/, /ru/). */
export function useLang(): Lang {
  const { lang } = useParams();
  return isLang(lang) ? lang : DEFAULT_LANG;
}
